import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NewReleasesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"new_releases"}/>
}
